import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=4ed2be7e&"
import script from "./ThemeToggle.vue?vue&type=script&lang=ts&"
export * from "./ThemeToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports